var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { AutocompleteInput, Button, SaveButton, SimpleForm, Toolbar, useNotify, } from "react-admin";
import { Preview, ContentCopy } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { Sequent_Backend_Support_Material_Select_Column, } from "@/gql/graphql";
import { SettingsContext } from "@/providers/SettingsContextProvider";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { PREPARE_BALLOT_PUBLICATION_PREVIEW } from "@/queries/PrepareBallotPublicationPreview";
import { GET_AREAS } from "@/queries/GetAreas";
import { TenantContext } from "@/providers/TenantContextProvider";
import { GET_DOCUMENT_BY_NAME } from "@/queries/GetDocumentByName";
import { CircularProgress } from "@mui/material";
import { useWidgetStore } from "@/providers/WidgetsContextProvider";
import { ETasksExecution } from "@/types/tasksExecution";
var ActionType;
(function (ActionType) {
    ActionType[ActionType["Copy"] = 0] = "Copy";
    ActionType[ActionType["Open"] = 1] = "Open";
})(ActionType || (ActionType = {}));
export var EditPreview = function (props) {
    var publicationId = props.publicationId, close = props.close, electionEventId = props.electionEventId, ballotData = props.ballotData;
    var t = useTranslation().t;
    var notify = useNotify();
    var globalSettings = useContext(SettingsContext).globalSettings;
    var _a = useWidgetStore(), addWidget = _a[0], setWidgetTaskId = _a[1], updateWidgetFail = _a[2];
    var _b = useState([]), sourceAreas = _b[0], setSourceAreas = _b[1];
    var preparePreview = useMutation(PREPARE_BALLOT_PUBLICATION_PREVIEW)[0];
    var _c = React.useState(false), isUploading = _c[0], setIsUploading = _c[1];
    var tenantId = useContext(TenantContext).tenantId;
    var _d = useState(null), areaId = _d[0], setAreaId = _d[1];
    var _e = useState(null), documentId = _e[0], setDocumentId = _e[1];
    var _f = useState(null), action = _f[0], setAction = _f[1];
    var getDocumentByName = useLazyQuery(GET_DOCUMENT_BY_NAME)[0];
    var areas = useQuery(GET_AREAS, {
        variables: {
            electionEventId: electionEventId,
        },
    }).data;
    //Show only relevant areas in dropdown
    var areaIds = useMemo(function () {
        var _a, _b;
        var areaIds = ((_b = (_a = ballotData === null || ballotData === void 0 ? void 0 : ballotData.current) === null || _a === void 0 ? void 0 : _a.ballot_styles) === null || _b === void 0 ? void 0 : _b.map(function (style) { return ({
            id: style.area_id,
        }); })) || [];
        return areaIds;
    }, [ballotData]);
    useEffect(function () {
        if (areas) {
            var filtered = areas.sequent_backend_area.filter(function (area) {
                return areaIds.some(function (areaId) { return areaId.id === area.id; });
            });
            setSourceAreas(filtered);
        }
    }, [areas, areaIds]);
    // This useEffect handles file upload
    useEffect(function () {
        var preparePreviewData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var currWidget, data, task_id, _error_1;
            var _a, _b, _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        currWidget = addWidget(ETasksExecution.PREPARE_PUBLICATION_PREVIEW, undefined);
                        _f.label = 1;
                    case 1:
                        _f.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, preparePreview({
                                variables: {
                                    electionEventId: electionEventId,
                                    ballotPublicationId: publicationId,
                                },
                            })];
                    case 2:
                        data = (_f.sent()).data;
                        if (!((_a = data === null || data === void 0 ? void 0 : data.prepare_ballot_publication_preview) === null || _a === void 0 ? void 0 : _a.document_id)) {
                            console.log((_b = data === null || data === void 0 ? void 0 : data.prepare_ballot_publication_preview) === null || _b === void 0 ? void 0 : _b.error_msg);
                            updateWidgetFail(currWidget.identifier);
                            notifyActionError();
                            return [2 /*return*/];
                        }
                        task_id = (_d = (_c = data === null || data === void 0 ? void 0 : data.prepare_ballot_publication_preview) === null || _c === void 0 ? void 0 : _c.task_execution) === null || _d === void 0 ? void 0 : _d.id;
                        task_id
                            ? setWidgetTaskId(currWidget.identifier, task_id, function () {
                                return onSuccessPreparePreview();
                            })
                            : updateWidgetFail(currWidget.identifier);
                        return [2 /*return*/, (_e = data === null || data === void 0 ? void 0 : data.prepare_ballot_publication_preview) === null || _e === void 0 ? void 0 : _e.document_id];
                    case 3:
                        _error_1 = _f.sent();
                        setIsUploading(false);
                        currWidget && updateWidgetFail(currWidget.identifier);
                        notifyActionError();
                        return [2 /*return*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        var handleDocumentProcess = function () { return __awaiter(void 0, void 0, void 0, function () {
            var docId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, preparePreviewData()];
                    case 1:
                        docId = _a.sent();
                        setDocumentId(docId);
                        return [2 /*return*/];
                }
            });
        }); };
        if (isUploading && areaId && undefined !== Sequent_Backend_Support_Material_Select_Column) {
            handleDocumentProcess();
        }
    }, [isUploading, areaId]);
    var onSuccessPreparePreview = function () {
        setIsUploading(false); // This will trigger and validate the condition in useEffect for action (open or copy)
    };
    var onPreviewClick = function (res) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!documentId) {
                setIsUploading(true);
            }
            setAction(ActionType.Open);
            return [2 /*return*/];
        });
    }); };
    var onCopyPreviewLinkClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!documentId) {
                setIsUploading(true);
            }
            setAction(ActionType.Copy);
            return [2 /*return*/];
        });
    }); };
    var notifyActionError = function () {
        if (action === ActionType.Copy) {
            notify(t("publish.preview.copy_error"), { type: "error" });
        }
        else if (action === ActionType.Open) {
            notify(t("publish.dialog.error_preview"), { type: "error" });
        }
    };
    // This useEffect handles logic for action (open or copy)
    useEffect(function () {
        var openPreview = function (previewUrl) {
            try {
                window.open(previewUrl, "_blank");
                if (close)
                    close();
                notify(t("publish.preview.success"), { type: "success" });
            }
            catch (_a) {
                notify(t("publish.dialog.error_preview"), { type: "error" });
            }
        };
        var copyPreviewLink = function (previewUrl) { return __awaiter(void 0, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, navigator.clipboard.writeText(previewUrl)];
                    case 1:
                        _b.sent();
                        if (close)
                            close();
                        notify(t("publish.preview.copy_success"), { type: "success" });
                        return [3 /*break*/, 3];
                    case 2:
                        _a = _b.sent();
                        notify(t("publish.preview.copy_error"), { type: "error" });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        if (documentId && !isUploading) {
            var previewUrl = getPreviewUrl(documentId);
            if (previewUrl && action === ActionType.Copy) {
                copyPreviewLink(previewUrl);
            }
            else if (previewUrl && action === ActionType.Open) {
                openPreview(previewUrl);
            }
        }
    }, [documentId, action, isUploading]);
    // Create preview url from data
    var previewUrlTemplate = useMemo(function () {
        return "".concat(globalSettings.VOTING_PORTAL_URL, "/preview/").concat(tenantId);
    }, [globalSettings.VOTING_PORTAL_URL, publicationId]);
    var getPreviewUrl = useCallback(function (documentId) {
        if (!documentId || !areaId || !publicationId) {
            return null;
        }
        return "".concat(previewUrlTemplate, "/").concat(documentId, "/").concat(areaId, "/").concat(publicationId);
    }, [previewUrlTemplate, areaId, publicationId]);
    return (_jsxs(SimpleForm, { toolbar: false, onSubmit: onPreviewClick, children: [_jsx(AutocompleteInput, { source: "area_id", choices: sourceAreas, optionText: function (area) { return area.name; }, label: String(t("publish.preview.publicationAreas")), fullWidth: true, debounce: 100, onChange: function (res) { return setAreaId(res); } }), _jsx(Toolbar, { sx: { display: "flex", background: "white", padding: "0 !important", gap: "1rem" }, children: isUploading ? (_jsx(CircularProgress, {})) : (_jsxs(_Fragment, { children: [_jsx(SaveButton, { disabled: !areaId, icon: _jsx(Preview, {}), label: String(t("publish.preview.action")) }), _jsx(Button, { disabled: !areaId, startIcon: _jsx(ContentCopy, {}), label: String(t("publish.preview.copy")), onClick: onCopyPreviewLinkClick })] })) })] }));
};
